import { render, staticRenderFns } from "./CoreItemThree.vue?vue&type=template&id=6b12ac22&scoped=true&"
import script from "./CoreItemThree.vue?vue&type=script&lang=js&"
export * from "./CoreItemThree.vue?vue&type=script&lang=js&"
import style0 from "./CoreItemThree.vue?vue&type=style&index=0&id=6b12ac22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b12ac22",
  null
  
)

export default component.exports